import { useMutation } from "react-query";
import { getFreshAccessToken } from "../use-user";

const UPDATE_TAKEBACK = `
  mutation UpdateTakeback($id: String!, $input: TakebackInput!) {
    updateTakeback(id: $id, input: $input) {
      success
      message
      eventId
      queued
    }
  }
`;

export const useUpdateTakeback = () => {
  return useMutation({
    mutationFn: async (variables) => {
      const accessToken = getFreshAccessToken();
      const res = await fetch(`${process.env.REACT_APP_TES_URL}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-client-id": process.env.REACT_APP_CLIENT_ID || "lego-test",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ query: UPDATE_TAKEBACK, variables }),
      });

      return res.json();
    },
  });
};
